import PropTypes from "prop-types";
import { Typography } from "core/typography/Typography";

// Shared header for a wizard step: the question alone. The kicker above it is
// the position among the five slots, rendered once by the bench — repeating the
// step's own name here would say twice what the highlighted slot already shows.
const StepHeader = ({ children }) => (
  // title-3 is the charter heading (24px/900, fluid): every step question of
  // the wizard goes through it rather than a hand-set font-size.
  <Typography
    type="h2"
    className="faf-question title-3 deep-purple"
    label={children}
  />
);

StepHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StepHeader;
